import { sv as sv$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var sv = {
  language: 'sv',
  country: 'se',
  name: 'Svenska',
  embeddedLocale: merge(error, login),
  flags: ['SE'],
  dateFns: sv$1,
  format: {
    date: 'yyyy-MM-dd',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { sv as default };
